(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.filter('RfGlobalLongDateTimeFilter', [RfGlobalLongDateTimeFilterFn]);

    // long-date filter (day-name, day, month-name, year, hour, minute), uses moment.locale (set on login)
    function RfGlobalLongDateTimeFilterFn() {
        return function (date) {
            if (date) {
                var dateMoment = moment(date);
                return dateMoment.format('LLLL');
            }
            return date;
        };
    }
})();